export const shopProducts = [
  {
    id: "p1",
    name: "Atelier Wrap Coat",
    material: "Regenerative wool · undyed",
    price: 480,
    category: "Outerwear",
    image:
      "https://readdy.ai/api/search-image?query=long%20oversized%20wrap%20coat%20in%20natural%20undyed%20wool%20draped%20on%20minimalist%20mannequin%2C%20warm%20cream%20background%2C%20soft%20diffused%20studio%20light%2C%20sustainable%20fashion%20product%20photography%2C%20sculptural%20silhouette%2C%20clean%20editorial%20composition%2C%20earth%20tone%20palette%2C%20artisanal%20craftsmanship%20feel&width=900&height=1200&seq=verdant-p1&orientation=portrait",
    isNew: false,
    isBestseller: true,
  },
  {
    id: "p2",
    name: "Field Linen Dress",
    material: "European flax linen",
    price: 295,
    category: "Dresses",
    image:
      "https://readdy.ai/api/search-image?query=flowing%20long%20linen%20dress%20in%20natural%20beige%20oat%20color%2C%20draped%20on%20studio%20stand%2C%20simple%20warm%20cream%20background%2C%20soft%20natural%20light%20from%20side%2C%20sustainable%20fashion%20editorial%20product%20shot%2C%20minimalist%20composition%2C%20artisanal%20texture%20detail%2C%20serene%20mood&width=900&height=1200&seq=verdant-p2&orientation=portrait",
    isNew: true,
    isBestseller: false,
  },
  {
    id: "p3",
    name: "Stone Knit Sweater",
    material: "Recycled cashmere blend",
    price: 340,
    category: "Knitwear",
    image:
      "https://readdy.ai/api/search-image?query=chunky%20oversized%20knit%20sweater%20in%20stone%20gray%20wool%2C%20studio%20product%20photography%20on%20warm%20bone%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20visible%20rich%20knit%20texture%20detail%2C%20sustainable%20slow%20fashion%20brand%20catalog%20shot%2C%20clean%20minimal%20composition&width=900&height=1200&seq=verdant-p3&orientation=portrait",
    isNew: false,
    isBestseller: true,
  },
  {
    id: "p4",
    name: "Clay Wide Trouser",
    material: "Organic hemp cotton",
    price: 245,
    category: "Trousers",
    image:
      "https://readdy.ai/api/search-image?query=wide%20leg%20trousers%20in%20warm%20clay%20terracotta%20color%2C%20folded%20and%20styled%20on%20cream%20surface%2C%20sustainable%20fashion%20editorial%20product%20photography%2C%20natural%20studio%20light%2C%20artisanal%20texture%2C%20minimalist%20earth%20tone%20palette%2C%20fine%20art%20composition&width=900&height=1200&seq=verdant-p4&orientation=portrait",
    isNew: false,
    isBestseller: false,
  },
  {
    id: "p5",
    name: "Ember Silk Blouse",
    material: "Peace silk · plant dyed",
    price: 320,
    category: "Tops",
    image:
      "https://readdy.ai/api/search-image?query=soft%20silk%20blouse%20in%20warm%20rust%20terracotta%20color%2C%20draped%20on%20simple%20mannequin%2C%20warm%20cream%20studio%20background%2C%20natural%20soft%20light%2C%20sustainable%20fashion%20product%20shot%2C%20artisanal%20detail%2C%20elegant%20sculptural%20fabric%20fall%2C%20minimalist%20earth%20palette&width=900&height=1200&seq=verdant-p5&orientation=portrait",
    isNew: true,
    isBestseller: false,
  },
  {
    id: "p6",
    name: "Moss Overshirt",
    material: "Organic cotton twill",
    price: 275,
    category: "Outerwear",
    image:
      "https://readdy.ai/api/search-image?query=oversized%20button%20down%20overshirt%20in%20olive%20moss%20green%20organic%20cotton%2C%20draped%20on%20minimalist%20stand%2C%20warm%20cream%20studio%20background%2C%20soft%20natural%20light%2C%20sustainable%20fashion%20product%20photography%2C%20clean%20editorial%20composition%2C%20earth%20tone%20palette%2C%20artisanal%20texture&width=900&height=1200&seq=verdant-p6&orientation=portrait",
    isNew: true,
    isBestseller: false,
  },
  {
    id: "p7",
    name: "Sand Rib Tank",
    material: "Sea Island cotton",
    price: 145,
    category: "Tops",
    image:
      "https://readdy.ai/api/search-image?query=ribbed%20knit%20tank%20top%20in%20warm%20sand%20beige%20color%2C%20studio%20product%20photography%20on%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20visible%20fine%20rib%20texture%20detail%2C%20sustainable%20slow%20fashion%20brand%20catalog%20shot%2C%20clean%20minimal%20composition%2C%20elegant%20simplicity&width=900&height=1200&seq=verdant-p7&orientation=portrait",
    isNew: false,
    isBestseller: false,
  },
  {
    id: "p8",
    name: "Forest Wool Jacket",
    material: "British wool · brushed",
    price: 520,
    category: "Outerwear",
    image:
      "https://readdy.ai/api/search-image?query=structured%20tailored%20wool%20jacket%20in%20deep%20forest%20green%20color%2C%20draped%20on%20minimalist%20mannequin%2C%20warm%20cream%20studio%20background%2C%20soft%20diffused%20light%2C%20sustainable%20fashion%20product%20photography%2C%20clean%20editorial%20composition%2C%20earth%20tone%20palette%2C%20refined%20craftsmanship%20feel&width=900&height=1200&seq=verdant-p8&orientation=portrait",
    isNew: false,
    isBestseller: true,
  },
];

export const shopCategories = [
  "All",
  "Outerwear",
  "Dresses",
  "Knitwear",
  "Trousers",
  "Tops",
];

export const shopMaterials = [
  "Regenerative wool",
  "European flax linen",
  "Recycled cashmere",
  "Organic hemp cotton",
  "Peace silk",
  "Organic cotton",
  "Sea Island cotton",
  "British wool",
];